<template>
  <div class="all-table" v-loading="loading">
    <div class="all-option">
    	<div class="all-option-one">
    		<ul>
    			<li v-for="item in category" :key="item.id"><a @click="chooseCategory(item)" href="javascript:;" :class="{'option-one-state':item.ischeck}">{{item.categoryName}}</a></li>
    		</ul>
    	</div>
    </div>
    <div>
        <CourseList :frompage="frompage" @pagechange="pagechange" :total="total" :list="courselist"></CourseList>
    </div>

  </div>
</template>

<script>
import '../../assets/css/allcourse.css'
import {ApiGetkeyCategory,ApiGetCategoryChild} from '../../net/course/index.js'
import CourseList from '../CourseList/courseList.vue'
export default {
  data: function () {
    return {
      str: '重点课程',
      category : [],
      total : 20,
      loading : false,
      courselist : [],
      currentid : null,
      frompage : 'ICourse'
    }
  },
  components: {
    CourseList
  },
  methods:{
    getgory(){
      ApiGetkeyCategory().then(res=>{
        if(res.code == 200){
          if(this.$route.query.id){
            this.category = res.value.map((item,index) => {
              return {...item,ischeck:item.id == this.$route.query.id ? true : false}
            })
            this.currentid = this.$route.query.id
          }else{
            this.category = res.value.map(function(item,index){
              return {...item,ischeck:index == 0 ? true : false}
            })
            this.currentid = this.category[0].id;
          }

          this.getCourse(1);
        }
      })
    },
    getCourse(index){
      this.loading = true
      const params= {
        keyCategoryId : this.currentid,
        pageNum : index,
        pageSize : 20,
        platform : 'pc'
      }
      ApiGetCategoryChild(params).then(res=>{
        if(res.code == 200){
          this.total = res.pc.page.total
          if(res.pc.categories.length > 0){
            this.categoryChild = res.pc.categories.map(function(i){
              return {...i,ischeck:false}
              })
          }
          this.courselist = res.pc.page.details;

        }
        this.loading = false
      }).catch(err=>{
          this.loading = false
        })
    },
    pagechange(index){
      this.getCourse(index);
    },
    chooseCategory(item){
      if(!item.ischeck){
        this.clicktype = 0;
        this.category = this.category.map(function(i){
          return {...i,ischeck : i.id == item.id ? true : false}
        })
        this.currentid = item.id;
        this.getCourse(1)
      }
    }
  },
  mounted() {
    this.getgory();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ICourse/ICourse.vue